export const extractHostName = (url: string): string => {
  const extractedUrl = url?.replace(/^https?:\/\//, '').replace(/^www\./, '')
  return extractedUrl ?? ''
}
